import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { List, Modal, Tooltip, Popconfirm, Button, message } from 'antd'
import { DeleteTwoTone, BranchesOutlined, DiffOutlined } from '@ant-design/icons'
import { setCurrentBranch } from 'Actions/branches'
import { BranchDiffer } from 'Components'

BranchListItem = ({ currentBranch, branches, setCurrentBranch, branch }) ->

  [modal, contextHolder] = Modal.useModal()

  switchBranch = (branch) ->
    return if currentBranch is branch.id()
    setCurrentBranch(branch.id())
    Weaver.getInstance().useBranch(branch)

  <List.Item>
    { contextHolder }
    <Link
      to="#"
      style={{ padding: 0 }}
      data-testid="branch-#{branch.id()}"
      onClick={ -> switchBranch(branch) }
    >
      { branch.name() }
    </Link>
  </List.Item>

mapStateToProps = ({ branches }) ->
  {
    currentBranch: branches.currentBranch
    branches: branches.branches
  }

export default connect(
  mapStateToProps,
  { setCurrentBranch }
)(BranchListItem)
